import React from 'react';
import ChakraIcon from '../common/ChakraIcon';
import { Link as RouterLink } from 'react-router-dom';
import {
  Box,
  Container,
  SimpleGrid,
  Stack,
  Text,
  Flex,
  Link,
  Image,
  Heading,
  Input,
  Button,
  HStack,
  VStack,
  Divider,
  useColorModeValue,
} from '@chakra-ui/react';
import { FaFacebook, FaTwitter, FaInstagram, FaLinkedin, FaMapMarkerAlt, FaEnvelope, FaPhone } from 'react-icons/fa';

const Footer: React.FC = () => {
  return (
    <Box
      bg="gray.900"
      color="white"
      mt="auto"
    >
      <Container as={Stack} maxW="container.xl" py={10}>
        <SimpleGrid columns={{ base: 1, sm: 2, md: 4 }} spacing={8}>
          <Stack spacing={6}>
            <Box>
              <Image src="/assets/logo.png" alt="ACTION FOR LIFE PEACE AND HOPE ADVANCEMENT (ALPHA) Logo" h="80px" objectFit="contain" />
            </Box>
            <Text fontSize="sm">
              ACTION FOR LIFE PEACE AND HOPE ADVANCEMENT (ALPHA) is a collaborative, faith-based, non-political, non-religious, and non-racial non-profit organization.
            </Text>
            <HStack spacing={4}>
              <Link href="https://www.facebook.com/sikiryamuba.bruno" isExternal aria-label="Facebook">
                <ChakraIcon icon={FaFacebook} boxSize="20px" />
              </Link>
            </HStack>
          </Stack>

          <Stack align="flex-start">
            <Heading as="h4" size="md" mb={2} fontWeight="600">
              Quick Links
            </Heading>
            <Link as={RouterLink} to="/">Home</Link>
            <Link as={RouterLink} to="/about">About Us</Link>
            <Link as={RouterLink} to="/programs">Programs</Link>
            <Link as={RouterLink} to="/target-groups">Target Groups</Link>
            <Link as={RouterLink} to="/get-involved">Get Involved</Link>
            <Link as={RouterLink} to="/impact-stories">Impact Stories</Link>
            <Link as={RouterLink} to="/contact">Contact Us</Link>
          </Stack>

          <Stack align="flex-start">
            <Heading as="h4" size="md" mb={2} fontWeight="600">
              Contact Info
            </Heading>
            <HStack align="flex-start" spacing={2}>
              <ChakraIcon icon={FaMapMarkerAlt} boxSize="16px" mt="4px" />
              <Text>Kasindi, Basongora, Beni, North Kivu Province, DRC</Text>
            </HStack>
            <HStack align="flex-start" spacing={2}>
              <ChakraIcon icon={FaEnvelope} boxSize="16px" mt="4px" />
              <Link href="mailto:shalomeprojects@gmail.com">shalomeprojects@gmail.com</Link>
            </HStack>
            <HStack align="flex-start" spacing={2}>
              <ChakraIcon icon={FaPhone} boxSize="16px" mt="4px" />
              <Link href="tel:+243975622685">+243 975 622 685</Link>
            </HStack>
          </Stack>

          <Stack align="flex-start">
            <Heading as="h4" size="md" mb={2} fontWeight="600">
              Newsletter
            </Heading>
            <Text>Subscribe to our newsletter for updates on our work and impact.</Text>
            <Stack direction="column" spacing={2} w="100%">
              <Input
                placeholder="Your email"
                bg="whiteAlpha.100"
                border={0}
                _focus={{
                  bg: 'whiteAlpha.300',
                }}
              />
              <Button
                variant="primary"
                size="md"
                w="full"
              >
                Subscribe
              </Button>
            </Stack>
          </Stack>
        </SimpleGrid>
      </Container>
      
      <Divider borderColor="gray.700" />
      
      <Box py={4}>
        <Container maxW="container.xl">
          <VStack spacing={2}>
            <Flex
              align="center"
              width="100%"
              _before={{
                content: '""',
                borderBottom: '1px solid',
                borderColor: 'gray.700',
                flexGrow: 1,
                mr: 8,
              }}
              _after={{
                content: '""',
                borderBottom: '1px solid',
                borderColor: 'gray.700',
                flexGrow: 1,
                ml: 8,
              }}
            >
              <Text fontSize="sm" textAlign="center">
                © {new Date().getFullYear()} ACTION FOR LIFE PEACE AND HOPE ADVANCEMENT (ALPHA). All rights reserved.
              </Text>
            </Flex>
            <Text fontSize="xs" color="gray.500" textAlign="center">
              Designed & Developed by <Link href="https://kihembo.com" isExternal color="blue.400">Kihembo Wilbert</Link>
            </Text>
          </VStack>
        </Container>
      </Box>
    </Box>
  );
};

export default Footer;
